import { useMemo } from "react"
import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import ExamResult from "@/exam/pages/ExamResult"
import { ExamProvider } from "@/exam/context"
import { createPublicProvider } from "@/exam/provider"

export default function PublicExamResult() {
  const { orgId, runId } = useParams()
  const [sp] = useSearchParams()
  const score = sp.get("score") || "0"
  const full = sp.get("full") || "0"
  const provider = useMemo(() => createPublicProvider({ orgId, runId, preview: sp.get("preview") === "1" }), [orgId, runId, sp])
  const nav = useNavigate()
  return (
    <ExamProvider provider={provider}>
      <ExamResult
        scoreParam={score}
        fullParam={full}
        spendParam={sp.get("spend") || "0"}
        onRetry={() => nav(`/play/${orgId}/${runId}`)}
      />
    </ExamProvider>
  )
}
